{
  "memoryOwner.knowledge.items": "Bilgi öğeleri",
  "memoryOwner.knowledge.archive": "Arşivle",
  "memoryOwner.knowledge.archived": "Bilgi öğesi arşivlendi",
  "memoryOwner.knowledge.archived_description": "İlişkileri korunarak Arşiv'de kalır ve geri alınabilir.",
  "memoryOwner.related.title": "İlgili hafıza",
  "memoryOwner.related.description": "Bu notla açık proje, ilişki veya yaşam bağlamını paylaşan kayıtlar.",
  "memoryOwner.related.refresh": "Yenile",
  "memoryOwner.related.load_error": "İlgili hafıza yüklenemedi",
  "memoryOwner.related.load_error_description": "Açık bağlantıları yenileyip yeniden deneyin.",
  "memoryOwner.related.empty": "Henüz ilgili kayıt yok",
  "memoryOwner.related.empty_description": "Bu nota bir proje veya ilişki ekleyin; aynı açık bağlamdaki kayıtlar burada görünür.",
  "memoryOwner.related.results": "İlgili kayıtlar",
  "memoryOwner.related.untitled": "Başlıksız kayıt",
  "memoryOwner.related.type.note": "Not",
  "memoryOwner.related.type.moment": "An",
  "memoryOwner.related.type.draft": "Taslak",
  "memoryOwner.related.type.life_item": "Yaşam kaydı",
  "memoryOwner.related.type.decision": "Karar",
  "memoryOwner.related.type.focus": "Odak oturumu"
}
